/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.groups.roles.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.notice',
  'acme.view.application.groups.roles.addModal.controllers',
  'acme.view.application.groups.roles.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('GroupsRolesController', ['$scope', '$state', '$timeout', '$uibModal', 'ApiService', 'NoticeFactory', 'GroupData', 'GridStateFactory', function($scope, $state, $timeout, $uibModal, ApiService, NoticeFactory, GroupData, GridStateFactory) {

    $scope.groupsRoles = {

      model: [],
      addModal: {},
      group: {},

      isLoaded: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.groupsRoles.gridDoubleClick(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          },
          {
            field: 'name',
            displayName: 'Role'
          }
        ]
      },

      init: function() {

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getRoles($state.params.id);

        // Content title set after initialization
        if (GroupData.data && GroupData.data.success) {
          this.success.init(GroupData);
        }else{
          this.error.init(GroupData);
        }

      },

      getRoles: function(id) {
        ApiService.groups.roles.list(id, this.gridState.getGridState()).then(this.success.getRoles, this.error.getRoles);
      },

      findRole: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              role: this.model[i],
              index: i
            };
          }
        }

        return r;

      },

      getRoleIds: function() {
        var i, ii,
          ids = [];

        for (i=0,ii=this.model.length;i<ii;i++) {
          ids.push(this.model[i].userGroupRoleId);
        }

        return ids;
      },

      getDeltas: function(list) {
        var i, ii,
            j, jj,
            remove,
            r = {
              ids: [],
              list: {
                mappings: angular.copy(list.mappings),
                roles: angular.copy(list.roles)
              }
            };

        // Only return items to be removed from the list
        // Splice out duplicates to only retain unique values
        for (i=0,ii=this.model.length;i<ii;i++) {
          remove = true;
          for (j=r.list.mappings.length - 1,jj=0;j>=jj;j--) {
            if (this.model[i].id === r.list.mappings[j].roleId) {
              console.log('GroupsRolesController::getRemovals', this.model[i].id, r.list.mappings[j].roleId);
              r.list.mappings.splice(j, 1);
              r.list.roles.splice(j, 1);
              remove = false;
              break;
            }
          }
          if (remove && this.model[i].userGroupRoleId) {
            r.ids.push(this.model[i].userGroupRoleId);
          }
        }
        console.log('GroupsRolesController::getRemovals', r);

        return r;
      },

      addBatch: function(list, deltaList) {
        var batchMappings = list.mappings;

        if (deltaList && deltaList.hasOwnProperty('mappings')) {
          batchMappings = deltaList.mappings;
        }

        ApiService.groups.roleMaps.batchCreate({ mappings: batchMappings }).then(function (response, status, headers, config) {
          var i, ii,
              j, jj,
              self = $scope.groupsRoles,
              mappings = response.data.payload;

          // Remap userGroupRoleIds to model for deletions to work
          for (i=0,ii=mappings.length;i<ii;i++) {
            for (j=0,jj=list.roles.length;j<jj;j++) {
              if (mappings[i].roleId === list.roles[j].id) {
                list.roles[j].userGroupRoleId = mappings[i].id;
              }
            }
          }
          self.model = list.roles;
          self.success.addBatch(response, status, headers, config);
        }, this.error.addBatch);

      },

      add: function() {
        var self = $scope.groupsRoles;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/roles/modals/addRoles.tpl.html',
          size: 'md',
          controller: 'GroupsRolesAddModalController',
          resolve: {
            groupData: function() {
              return self.group;
            },
            groupRoles: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (list) {
          var delta = self.getDeltas(list);
          
          if (delta.ids.length > 0) {
            ApiService.groups.roleMaps.remove({ ids: delta.ids }).then(function (response) {
              // Clear roles to prevent duplicates
              self.model = [];
              // Add roles from original list not deltas
              self.addBatch(list, delta.list);
            }, self.error.add);
          }else{
            self.addBatch(list, delta.list);
          }
        }, function () {
          // Do nothing
        });
      },

      remove: function(id) {
        var self = $scope.groupsRoles,
          found = self.findRole(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/roles/modals/removeRole.tpl.html',
          size: 'md',
          controller: 'GroupsRolesRemoveModalController',
          resolve: {
            currentRole: function() {
              return found.role;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.groups.roleMaps.remove({ ids: found.role.userGroupId }).then(function(response, status, headers, config) {
            self.model.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      success: {
        init: function(response) {
          var self = $scope.groupsRoles;
          self.group = response.data.payload;
          $scope.$emit('Application::contentTitleChange', {
            title: self.group.displayName || self.group.name,
            buttonRight: {
              label: 'Add Roles',
              action: function() {
                $scope.groupsRoles.add();
              }
            }
          });
        },
        getRoles: function(response) {
          var self = $scope.groupsRoles;
          self.model = response.data.payload.list;
          //next tick
          $timeout(function() {
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.isLoaded = true;
          }, 0);
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      error: {
        init: function(response) {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Group Roles',
            buttonRight: {
              label: 'Add Roles',
              permissions: 'USER_GROUPS_UPDATE',
              action: function() {
                $scope.groupsRoles.add();
              }
            }
          });
        },
        getRoles: function(response) {
          var self = $scope.groupsRoles;
          self.isLoaded = true;
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      gridDoubleClick: function(row) {
        $state.go('application.roles.permissions', { id: row.entity.id });
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.groupsRoles;
        self.gridState.updateGridState(newPage, pageSize);
        self.getRoles($state.params.id);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.groupsRoles, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getRoles($state.params.id);
        }
      }

    };

    $scope.groupsRoles.init();

}]);